import { CountrySelect } from '../../components/ui/CountrySelect';
import { FormSection } from '../../components/ui/FormSection';

interface AddressSectionProps {
  street: string;
  onStreetChange: (value: string) => void;
  city: string;
  onCityChange: (value: string) => void;
  state: string;
  onStateChange: (value: string) => void;
  zipCode: string;
  onZipCodeChange: (value: string) => void;
  country: string;
  onCountryChange: (value: string) => void;
}

export const AddressSection = ({
  street,
  onStreetChange,
  city,
  onCityChange,
  state,
  onStateChange,
  zipCode,
  onZipCodeChange,
  country,
  onCountryChange,
}: AddressSectionProps) => (
  <FormSection title="Address">
    <div>
      <label htmlFor="street" className="block text-sm font-medium text-gray-700 mb-1">
        Street Address *
      </label>
      <input
        type="text"
        id="street"
        value={street}
        onChange={(e) => onStreetChange(e.target.value)}
        className="w-full px-3 py-2 border border-gray-300 rounded-md"
        placeholder="123 Main St"
        required
      />
    </div>

    <div className="grid grid-cols-2 gap-4">
      <div>
        <label htmlFor="city" className="block text-sm font-medium text-gray-700 mb-1">
          City *
        </label>
        <input
          type="text"
          id="city"
          value={city}
          onChange={(e) => onCityChange(e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded-md"
          placeholder="Napa"
          required
        />
      </div>

      <div>
        <label htmlFor="state" className="block text-sm font-medium text-gray-700 mb-1">
          State *
        </label>
        <input
          type="text"
          id="state"
          value={state}
          onChange={(e) => onStateChange(e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded-md"
          placeholder="CA"
          required
        />
      </div>
    </div>

    <div className="grid grid-cols-2 gap-4">
      <div>
        <label htmlFor="zipCode" className="block text-sm font-medium text-gray-700 mb-1">
          Zip Code *
        </label>
        <input
          type="text"
          id="zipCode"
          value={zipCode}
          onChange={(e) => onZipCodeChange(e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded-md"
          placeholder="94558"
          required
        />
      </div>

      <CountrySelect
        label="Country"
        value={country}
        onChange={onCountryChange}
        placeholder="Start typing a country..."
        fullWidth
      />
    </div>
  </FormSection>
);
